module.exports = __webpack_public_path__ + "static/assets/f151dc9a8eb14b4d9c64795e1cbae7e0.mp3";